module.exports = __webpack_public_path__ + "img/map-location-dot.3b65bc7e.svg";